import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=3970c0ee&scoped=true&"
import script from "./_id.vue?vue&type=script&lang=js&"
export * from "./_id.vue?vue&type=script&lang=js&"
import style0 from "./_id.vue?vue&type=style&index=0&id=3970c0ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3970c0ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3970c0ee')) {
      api.createRecord('3970c0ee', component.options)
    } else {
      api.reload('3970c0ee', component.options)
    }
    module.hot.accept("./_id.vue?vue&type=template&id=3970c0ee&scoped=true&", function () {
      api.rerender('3970c0ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/_id.vue"
export default component.exports